<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Identificação do paciente"
            >
                <FormCidadao
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Profissional responsável"
                show-legend
            >
                <FormProfissional
                    :repositories="repositories"
                    :model="model"
                    :enums="enums"
                    :form="form"
                    :agendamento="agendamento"
                    :isAmbulatorio="isAmbulatorio"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Atendimento"
            >
                <FormAtendimento
                    :model="model"
                    :form="form"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Vigilância em saúde bucal *"
            >
                <FormVigilancia
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Problemas e/ou condições avaliados *"
            >
                <FormProblemaCondicao
                    :data="{ additionals, form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Medições"
            >
                <FormMedicoes
                    :model="model"
                    :form="form"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos(Quantidade)"
            >
                <FormQuantidade
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                v-if="model.cidadao && model.cidadao.idadeAnos >= 60"
                title="IVCF - Índice de vulnerabilidade clínico-funcional"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <p>
                            As perguntas são direcionadas à pessoa idosa e, quando possível, devem ser confirmadas pelo familiar ou acompanhante, desde
                            que convivam com a pessoa idosa e estejam em condições de responder aos questionamentos. Nas pessoas idosas incapazes de
                            responder, utilizar as respostas do cuidador.
                        </p>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-alert>Em geral o tempo de aplicação deste instrumento varia de 5 a 10 minutos.</rkm-alert>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            @change="handleDesejaPreencherChange"
                            label="Deseja preencher o IVCF 20 para esta pessoa?"
                            v-model="model.ivcf.desejaPreencher"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Nao</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <template v-if="model.ivcf.desejaPreencher">
                    <rkm-row>
                        <rkm-col>
                            <h5>Perguntas do instrumento</h5>
                        </rkm-col>
                    </rkm-row>

                    <rkm-area title="Idade do cidadão | Grupo 1 de 8">
                        <rkm-form-input
                            :value="model.cidadao.idade"
                            name="pacienteIdade"
                            readonly
                        />
                    </rkm-area>

                    <rkm-area no-margin-top title="Percepção da saúde | Grupo 2 de 8">
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.estadoSaudeGeral"
                                    label="Em geral, comparando com outras pessoas de sua idade, você diria que sua saúde é"
                                    v-model="model.ivcf.estadoSaudeGeral"
                                >
                                    <rkm-form-radio value="excelente_muito_boa_ou_boa">Excelente, muito boa ou boa</rkm-form-radio>
                                    <rkm-form-radio value="regular_ou_ruim">Regular ou ruim</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area no-margin-top title="Atividades de vida diária | Grupo 3 de 8">
                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Atividades de vida diária instrumental</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <p>Por causa de sua saúde ou condição física,</p>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.limitacaoCompras"
                                    label="Você deixou de fazer compras?"
                                    v-model="model.ivcf.limitacaoCompras"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não ou não faz compras por outros motivos que não a saúde</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.limitacaoGestaoFinanceira"
                                    label="Você deixou de controlar seu dinheiro, gastos ou pagar as contas de sua casa?"
                                    v-model="model.ivcf.limitacaoGestaoFinanceira"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não ou não controla o dinheiro por outros motivos que não a saúde</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.limitacaoTarefasDomesticas"
                                    label="Você deixou de realizar pequenos trabalhos domésticos, como lavar a louça, arrumar a casa ou fazer limpeza leve?"
                                    v-model="model.ivcf.limitacaoTarefasDomesticas"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não ou não faz mais pequenos trabalhos domésticos por outros motivos que não a saúde</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Atividades de vida diária básica</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.banhoIndependencia"
                                    label="Por causa de sua saúde ou condição física, você deixou de tomar banho sozinho?"
                                    v-model="model.ivcf.banhoIndependencia"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area no-margin-top title="Cognição | Grupo 4 de 8">
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.relatoEsquecimentoPorTerceiros"
                                    label="Algum familiar ou amigo falou que você está ficando esquecido?"
                                    v-model="model.ivcf.relatoEsquecimentoPorTerceiros"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.esquecimentoPiorando"
                                    label="Você tem um esquecimento que está piorando nos últimos meses?"
                                    v-model="model.ivcf.esquecimentoPiorando"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.esquecimentoImpactaAtividades"
                                    label="Você tem um esquecimento que está impedindo a realização de alguma atividade do cotidiano?"
                                    v-model="model.ivcf.esquecimentoImpactaAtividades"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area no-margin-top title="Humor | Grupo 5 de 8">
                        <rkm-row>
                            <rkm-col>
                                <p>No último mês,</p>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.humorTristezaDesanimo"
                                    label="Você ficou com desânimo, tristeza ou desesperança?"
                                    v-model="model.ivcf.humorTristezaDesanimo"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.perdaInteresseAtividades"
                                    label="Você perdeu o interesse ou prazer em atividades anteriormente prazerosas?"
                                    v-model="model.ivcf.perdaInteresseAtividades"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area no-margin-top title="Mobilidade | Grupo 6 de 8">
                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Alcance, preensão e pinça</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.limitacaoElevarBracos"
                                    label="Você é incapaz de elevar os braços acima do nível do ombro?"
                                    v-model="model.ivcf.limitacaoElevarBracos"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.limitacaoMotricidadeFina"
                                    label="Você é incapaz de manusear ou segurar pequenos objetos?"
                                    v-model="model.ivcf.limitacaoMotricidadeFina"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Capacidade aeróbica e/ou muscular</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.perdaPesoNaoIntencional"
                                    label="Você teve perda de peso não intencional de 4,5 kg ou 5% do peso corporal no último ano, 6 kg nos últimos 6 meses ou 3 kg no último mês?"
                                    v-model="model.ivcf.perdaPesoNaoIntencional"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.imcAbaixo22"
                                    label="Você tem Índice de Massa Corporal (IMC) menor que 22 kg/m²?"
                                    v-model="model.ivcf.imcAbaixo22"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.panturrilhaAbaixo31"
                                    label="Você tem a circunferência (perímetro) da panturrilha menor que 31 centímetros?"
                                    v-model="model.ivcf.panturrilhaAbaixo31"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.marchaLenta4mMaior5s"
                                    label="Em um teste de velocidade da marcha, o tempo gasto pela pessoa idosa para percorrer 4 metros é maior do que 5 segundos?"
                                    v-model="model.ivcf.marchaLenta4mMaior5s"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Marcha</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.dificuldadeCaminharImpactoAtividades"
                                    label="Você tem dificuldade para caminhar que possa impedir a realização de alguma atividade do cotidiano?"
                                    v-model="model.ivcf.dificuldadeCaminharImpactoAtividades"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.quedasRecorrentes"
                                    label="Você teve duas ou mais quedas no último ano?"
                                    v-model="model.ivcf.quedasRecorrentes"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Continência esfincteriana</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.incontinencia"
                                    label="Você perde urina ou fezes, sem querer, em algum momento?"
                                    v-model="model.ivcf.incontinencia"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area no-margin-top title="Comunicação | Grupo 7 de 8">
                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Visão</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.problemaVisaoImpactoAtividades"
                                    label="Você tem problemas de visão capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de óculos ou lentes de contato)"
                                    v-model="model.ivcf.problemaVisaoImpactoAtividades"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong class="text-info">Audição</strong>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.problemaAudicaoImpactoAtividades"
                                    label="Você tem problemas de audição capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de aparelhos de audição)"
                                    v-model="model.ivcf.problemaAudicaoImpactoAtividades"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area no-margin-top title="Comorbidade múltipla | Grupo 8 de 8">
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.doencasCronicasMultiplas"
                                    label="Você tem cinco ou mais doenças crônicas?"
                                    v-model="model.ivcf.doencasCronicasMultiplas"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.polifarmacia5OuMaisMedicamentos"
                                    label="Você faz uso regular de cinco ou mais medicamentos diferentes todos os dias?"
                                    v-model="model.ivcf.polifarmacia5OuMaisMedicamentos"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.ivcf.internacaoUltimos6Meses"
                                    label="Você teve alguma internação nos últimos 6 meses?"
                                    v-model="model.ivcf.internacaoUltimos6Meses"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <template v-if="pontuacaoIvcf > 0">
                        <rkm-area no-margin-top title="Pontuação final do IVCF 20">
                            <rkm-alert
                                v-if="pontuacaoIvcf <= 6"
                                color="success"
                            >
                                Idoso com BAIXO risco de vulnerabilidade Clínico-funcional – IDOSO ROBUSTO
                            </rkm-alert>

                            <rkm-alert
                                v-if="pontuacaoIvcf >= 7 && pontuacaoIvcf <= 14"
                                color="warning"
                            >
                                Idoso com MODERADO risco de vulnerabilidade Clínico-funcional – IDOSO EM RISCO DE FRAGILIZAÇÃO
                            </rkm-alert>

                            <rkm-alert
                                v-if="pontuacaoIvcf >= 15"
                                color="danger"
                            >
                                Idoso com ALTO risco de vulnerabilidade Clínico-funcional – IDOSO FRÁGIL
                            </rkm-alert>
                        </rkm-area>
                    </template>
                </template>
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos"
                class="mt-3"
            >

                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                    slot="trailing"
                    title="Adicionar"
                    small
                    :disabled="model.exportacao"
                >
                    <rkm-icon icon="plus"/>
                </rkm-button>

                <FormProcedimentos
                    :model="model"
                />
            </rkm-area>

            <BoxExame
                :form="form"
                :model="model"
            />

            <rkm-area
                type="fieldset"
                title="Fornecimento"
            >
                <FormFornecimento
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Conduta/ Desfecho *"
                no-margin-top
            >
                <FormCondutaEncaminhamento
                    :model="model"
                />
            </rkm-area>
        </rkm-form>

        <Modal
            :model="model"
            :form="form"
            :loaded="loaded"
            :repositories="repositories"
            ref="Modal"
        />
    </div>
</template>

<script>
import { repository, stringCase, data, object, formats, error } from "@/mixins";
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import procedimento from '@/enums/atencao-basica/atendimento-odontologico/procedimento'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import { mapActions } from "vuex";
import moment from 'moment'
import FormAtendimento from './components/atendimento/Form.vue'
import FormCidadao from './components/cidadao/Form.vue'
import FormCondutaEncaminhamento from './components/condutaEncaminhamento/Form.vue'
import BoxExame from './components/exame/Index'
import FormFornecimento from './components/fornecimento/Form.vue'
import FormMedicoes from './components/medicoes/Form.vue'
import FormProblemaCondicao from './components/problema-condicao/Index.vue'
import FormProcedimentos from './components/procedimento/Form.vue'
import FormProfissional from './components/profissional/Form.vue'
import FormQuantidade from './components/quantidade/Form.vue'
import FormVigilancia from './components/vigilancia/Form.vue'
import Modal from './components/procedimento/Modal'

export default {
    components: {
        BoxExame,
        FormAtendimento,
        FormCidadao,
        FormCondutaEncaminhamento,
        FormFornecimento,
        FormMedicoes,
        FormProblemaCondicao,
        FormProcedimentos,
        FormProfissional,
        FormQuantidade,
        FormVigilancia,
        Modal,
    },
    computed: {
        validations() {
            return {
                ivcf: {
                    estadoSaudeGeral: { required: true },
                    limitacaoCompras: { required: true },
                    limitacaoGestaoFinanceira: { required: true },
                    limitacaoTarefasDomesticas: { required: true },
                    banhoIndependencia: { required: true },
                    relatoEsquecimentoPorTerceiros: { required: true },
                    esquecimentoPiorando: { required: true },
                    esquecimentoImpactaAtividades: { required: true },
                    humorTristezaDesanimo: { required: true },
                    perdaInteresseAtividades: { required: true },
                    limitacaoElevarBracos: { required: true },
                    limitacaoMotricidadeFina: { required: true },
                    perdaPesoNaoIntencional: { required: true },
                    imcAbaixo22: { required: true },
                    panturrilhaAbaixo31: { required: true },
                    marchaLenta4mMaior5s: { required: true },
                    dificuldadeCaminharImpactoAtividades: { required: true },
                    quedasRecorrentes: { required: true },
                    incontinencia: { required: true },
                    problemaVisaoImpactoAtividades: { required: true },
                    problemaAudicaoImpactoAtividades: { required: true },
                    doencasCronicasMultiplas: { required: true },
                    polifarmacia5OuMaisMedicamentos: { required: true },
                    internacaoUltimos6Meses: { required: true },
                },
            }
        },
        pontuacaoIvcf() {
            let pontuacao = 0

            if (this.model.cidadao.idadeAnos >= 75 && this.model.cidadao.idadeAnos <= 84) {
                pontuacao += 1
            }
            else if (this.model.cidadao.idadeAnos >= 85) {
                pontuacao += 3
            }

            if (this.model.ivcf.estadoSaudeGeral === 'regular_ou_ruim') {
                pontuacao += 1
            }

            if (this.model.ivcf.limitacaoCompras || this.model.ivcf.limitacaoGestaoFinanceira || this.model.ivcf.limitacaoTarefasDomesticas) {
                pontuacao += 4
            }

            if (this.model.ivcf.banhoIndependencia) {
                pontuacao += 6
            }

            if (this.model.ivcf.relatoEsquecimentoPorTerceiros) {
                pontuacao += 1
            }

            if (this.model.ivcf.esquecimentoPiorando) {
                pontuacao += 1
            }

            if (this.model.ivcf.esquecimentoImpactaAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.humorTristezaDesanimo) {
                pontuacao += 2
            }

            if (this.model.ivcf.perdaInteresseAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.limitacaoElevarBracos) {
                pontuacao += 1
            }

            if (this.model.ivcf.limitacaoMotricidadeFina) {
                pontuacao += 1
            }

            if (this.model.ivcf.perdaPesoNaoIntencional || this.model.ivcf.imcAbaixo22 || this.model.ivcf.panturrilhaAbaixo31 || this.model.ivcf.marchaLenta4mMaior5s) {
                pontuacao += 2
            }

            if (this.model.ivcf.dificuldadeCaminharImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.quedasRecorrentes) {
                pontuacao += 2
            }

            if (this.model.ivcf.incontinencia) {
                pontuacao += 2
            }

            if (this.model.ivcf.problemaVisaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.problemaAudicaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.doencasCronicasMultiplas || this.model.ivcf.polifarmacia5OuMaisMedicamentos || this.model.ivcf.internacaoUltimos6Meses) {
                pontuacao += 4
            }

            return pontuacao
        },
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atendimentoOdontologico: this.getConectaSusRepository('atencaoBasica.atendimentoOdontologico')
        }
        this.load()
    },
    data: () => ({
        additionals: null,
        index: null,
        form: null,
        model: null,
        loaded: false,
        agendamento: null,
        enums: {
            permissao,
            procedimento,
            tipoAtendimento
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id && !this.edit) {
                this.setLoading()
                this.repositories.atendimentoOdontologico.create(this.id)
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        if (this.isAmbulatorio) {

                            this.$nextTick()
                                .then(() => {

                                    if (this.data.model.atendimentoOdontologico) {

                                        this.model = this.data.model.atendimentoOdontologico
                                    } else {

                                        this.model.cadastro.usuario = this.data.model.cadastro.usuario
                                        this.model.cadastro.unidadeId = this.data.model.cadastro.unidadeId
                                        this.model.cadastro.infraestruturaId = this.data.model.cadastro.infraestruturaId
                                        this.model.cadastro.equipeId = this.data.model.cadastro.equipeId
                                        this.model.cadastro.ocupacaoId = this.data.model.cadastro.ocupacaoId
                                        this.model.cadastro.dataUsuarioResponsavel = this.data.model.cadastro.dataUsuarioResponsavel
                                    }

                                    this.agendamento = this.data
                            })
                        }

                        this.$nextTick().then(() => this.loaded = true)

                        this.$emit('loaded', {additionals: this.additionals, model: this.model})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else if (this.edit) {
                this.setLoading()
                this.repositories.atendimentoOdontologico.edit(this.id)
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)
                        this.loaded = true

                        this.$emit('loaded', {additionals: this.additionals, model: this.model})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return
                    if(this.edit) {
                        this.setLoading()
                        this.repositories.atendimentoOdontologico.update(this.id, this.prepareData())
                            .then(({ data }) => {
                                this.showSaveNotification()
                                this.$emit('save', data)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                    else {
                        this.setLoading()
                        this.repositories.atendimentoOdontologico.store(this.prepareData())
                            .then(({ data }) => {
                                this.showSaveNotification()
                                this.$emit('save', data)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
            })
        },
        saveAmbulatorio() {

            return this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) {

                        this.$emit('focusTabAtendimentoOdontologico')
                        return false
                    } else {

                        this.$emit('saveAtendimentoOdontologico', this.model)
                        return true
                    }
            })
        },
        saveProcedimento() {
            const param = {
                id: this.model.procedimento.id,
                nome: this.model.procedimento.nome,
                codigo: this.model.procedimento.codigo,
            }
            if (this.index) {
                this.$set(this.model.procedimentos, this.index, this.clone(param))
            } else {
                this.model.procedimentos.push(this.clone(param))
            }

            this.resetForm()
        },
        prepareData() {
            return this.camelObjectKeysToSnakeRecursive({
                pacienteId: this.model.cidadao.pacienteId,
                usuarioId: this.model.cadastro.usuario.id,
                ocupacaoId: this.model.cadastro.ocupacaoId,
                usuarioAuxiliarId: this.model.cadastro.usuarioAuxiliar.id,
                ocupacaoAuxiliarId: this.model.cadastro.ocupacaoAuxiliarId,
                dataAtendimento: moment(this.model.cadastro.dataAtendimento).format('YYYY-MM-DD'),
                turnoId: this.model.atendimento.turnoId,
                localAtendimentoId: this.model.atendimento.localAtendimentoId,
                tipoAtendimentoId: this.model.atendimento.tipoAtendimentoId,
                tipoConsultaId: this.model.atendimento.tipoConsultaId,
                necessidadesEspeciais: this.model.atendimento.necessidadesEspeciais,
                gestante: this.model.atendimento.gestante,
                unidadeId: this.model.cadastro.unidadeId,
                equipeId: this.model.cadastro.equipeId,
                equipeAuxiliarId: this.model.cadastro.equipeAuxiliarId,
                escovaDental: this.model.fornecimento.escovaDental,
                cremeDental: this.model.fornecimento.cremeDental,
                fioDental: this.model.fornecimento.fioDental,
                vigilancia: this.model.vigilancia,
                condutaEncaminhamento: this.model.condutaEncaminhamento,
                condicaoAvaliada: this.model.condicaoAvaliada,
                doencaTransmissivel: this.model.doencaTransmissivel,
                problemasCondicoes: this.model.problemasCondicoes,
                rastreamento: this.model.rastreamento,
                medicoes: this.model.medicoes,
                procedimentos: this.prepareProcedimentos(),
                exames: this.model.exames.map(exame => ({exameId: exame.exame.id, solicitado: exame.solicitado, avaliado: exame.avaliado})),
                ivcf: {
                    desejaPreencher: this.model.ivcf.desejaPreencher,
                    estadoSaudeGeral: this.model.ivcf.estadoSaudeGeral,
                    limitacaoCompras: this.model.ivcf.limitacaoCompras,
                    limitacaoGestaoFinanceira: this.model.ivcf.limitacaoGestaoFinanceira,
                    limitacaoTarefasDomesticas: this.model.ivcf.limitacaoTarefasDomesticas,
                    banhoIndependencia: this.model.ivcf.banhoIndependencia,
                    relatoEsquecimentoPorTerceiros: this.model.ivcf.relatoEsquecimentoPorTerceiros,
                    esquecimentoPiorando: this.model.ivcf.esquecimentoPiorando,
                    esquecimentoImpactaAtividades: this.model.ivcf.esquecimentoImpactaAtividades,
                    humorTristezaDesanimo: this.model.ivcf.humorTristezaDesanimo,
                    perdaInteresseAtividades: this.model.ivcf.perdaInteresseAtividades,
                    limitacaoElevarBracos: this.model.ivcf.limitacaoElevarBracos,
                    limitacaoMotricidadeFina: this.model.ivcf.limitacaoMotricidadeFina,
                    perdaPesoNaoIntencional: this.model.ivcf.perdaPesoNaoIntencional,
                    imcAbaixo_22: this.model.ivcf.imcAbaixo22,
                    panturrilhaAbaixo_31: this.model.ivcf.panturrilhaAbaixo31,
                    marchaLenta_4mMaior_5s: this.model.ivcf.marchaLenta4mMaior5s,
                    dificuldadeCaminharImpactoAtividades: this.model.ivcf.dificuldadeCaminharImpactoAtividades,
                    quedasRecorrentes: this.model.ivcf.quedasRecorrentes,
                    incontinencia: this.model.ivcf.incontinencia,
                    problemaVisaoImpactoAtividades: this.model.ivcf.problemaVisaoImpactoAtividades,
                    problemaAudicaoImpactoAtividades: this.model.ivcf.problemaAudicaoImpactoAtividades,
                    doencasCronicasMultiplas: this.model.ivcf.doencasCronicasMultiplas,
                    polifarmacia_5OuMaisMedicamentos: this.model.ivcf.polifarmacia5OuMaisMedicamentos,
                    internacaoUltimos_6Meses: this.model.ivcf.internacaoUltimos6Meses,
                }
            })
        },
        prepareProcedimentos() {
            let procedimentos = this.clone(this.model.procedimentos)
            if(this.model.procedimentosQuantidade.acessoPolpaDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ACESSO_POLPA_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.acessoPolpaDentaria
                })
            }
            if(this.model.procedimentosQuantidade.adaptacaoProteseDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ADAPTACAO_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.adaptacaoProteseDentaria
                })
            }
            if(this.model.procedimentosQuantidade.aplicacaoCariostatico) {
                procedimentos.push({
                    codigo: this.enums.procedimento.APLICACAO_CARIOSTATICO,
                    quantidade: this.model.procedimentosQuantidade.aplicacaoCariostatico
                })
            }
            if(this.model.procedimentosQuantidade.aplicacaoSelante) {
                procedimentos.push({
                    codigo: this.enums.procedimento.APLICACAO_SELANTE,
                    quantidade: this.model.procedimentosQuantidade.aplicacaoSelante
                })
            }
            if(this.model.procedimentosQuantidade.aplicacaoTopicaFluor) {
                procedimentos.push({
                    codigo: this.enums.procedimento.APLICACAO_TOPICA_FLUOR,
                    quantidade: this.model.procedimentosQuantidade.aplicacaoTopicaFluor
                })
            }
            if(this.model.procedimentosQuantidade.capeamentoPulpar) {
                procedimentos.push({
                    codigo: this.enums.procedimento.CAPEAMENTO_PULPAR,
                    quantidade: this.model.procedimentosQuantidade.capeamentoPulpar
                })
            }
            if(this.model.procedimentosQuantidade.cimentacaoProtese) {
                procedimentos.push({
                    codigo: this.enums.procedimento.CIMENTACAO_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.cimentacaoProtese
                })
            }
            if(this.model.procedimentosQuantidade.curativoDemora) {
                procedimentos.push({
                    codigo: this.enums.procedimento.CURATIVO_DEMORA,
                    quantidade: this.model.procedimentosQuantidade.curativoDemora
                })
            }
            if(this.model.procedimentosQuantidade.drenagemAbscesso) {
                procedimentos.push({
                    codigo: this.enums.procedimento.DRENAGEM_ABSCESSO,
                    quantidade: this.model.procedimentosQuantidade.drenagemAbscesso
                })
            }
            if(this.model.procedimentosQuantidade.evidenciacaoPlacaBacteriana) {
                procedimentos.push({
                    codigo: this.enums.procedimento.EVIDENCIACAO_PLACA_BACTERIANA,
                    quantidade: this.model.procedimentosQuantidade.evidenciacaoPlacaBacteriana
                })
            }
            if(this.model.procedimentosQuantidade.exodontiaDenteDeciduo) {
                procedimentos.push({
                    codigo: this.enums.procedimento.EXODONTIA_DENTE_DECIDUO,
                    quantidade: this.model.procedimentosQuantidade.exodontiaDenteDeciduo
                })
            }
            if(this.model.procedimentosQuantidade.exodontiaDentePermanente) {
                procedimentos.push({
                    codigo: this.enums.procedimento.EXODONTIA_DENTE_PERMANENTE,
                    quantidade: this.model.procedimentosQuantidade.exodontiaDentePermanente
                })
            }
            if(this.model.procedimentosQuantidade.instalacaoProteseDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.INSTALACAO_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.instalacaoProteseDentaria
                })
            }
            if(this.model.procedimentosQuantidade.moldagemProteseDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.MOLDAGEM_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.moldagemProteseDentaria
                })
            }
            if(this.model.procedimentosQuantidade.orientacaoHigieneBucal) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ORIENTACAO_HIGIENE_BUCAL,
                    quantidade: this.model.procedimentosQuantidade.orientacaoHigieneBucal
                })
            }
            if(this.model.procedimentosQuantidade.orientacaoIndividualEmSaude) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ORIENTACAO_INDIVIDUAL_EM_SAUDE,
                    quantidade: this.model.procedimentosQuantidade.orientacaoIndividualEmSaude
                })
            }
            if(this.model.procedimentosQuantidade.remocaoPlacaBacteriana) {
                procedimentos.push({
                    codigo: this.enums.procedimento.REMOCAO_PLACA_BACTERIANA,
                    quantidade: this.model.procedimentosQuantidade.remocaoPlacaBacteriana
                })
            }
            if(this.model.procedimentosQuantidade.pulpotomiaDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.PULPOTOMIA_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.pulpotomiaDentaria
                })
            }
            if(this.model.procedimentosQuantidade.raspagemSupragengivais) {
                procedimentos.push({
                    codigo: this.enums.procedimento.RASPAGEM_SUPRAGENGIVAIS,
                    quantidade: this.model.procedimentosQuantidade.raspagemSupragengivais
                })
            }
            if(this.model.procedimentosQuantidade.raspagemSubgengivais) {
                procedimentos.push({
                    codigo: this.enums.procedimento.RASPAGEM_SUBGENGIVAIS,
                    quantidade: this.model.procedimentosQuantidade.raspagemSubgengivais
                })
            }
            if(this.model.procedimentosQuantidade.restauracaoDentePermanenteAnterior) {
                procedimentos.push({
                    codigo: this.enums.procedimento.RESTAURACAO_DENTE_PERMANENTE_ANTERIOR,
                    quantidade: this.model.procedimentosQuantidade.restauracaoDentePermanenteAnterior
                })
            }
            if(this.model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.SELAMENTO_PROVISORIO_CAVIDADE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria
                })
            }
            if(this.model.procedimentosQuantidade.tratamentoAlveolite) {
                procedimentos.push({
                    codigo: this.enums.procedimento.TRATAMENTO_ALVEOLITE,
                    quantidade: this.model.procedimentosQuantidade.tratamentoAlveolite
                })
            }
            if(this.model.procedimentosQuantidade.ulotomiaUlectomia) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                    quantidade: this.model.procedimentosQuantidade.ulotomiaUlectomia
                })
            }
            return procedimentos
        },
        hasValue(atendimento) {

            return Object.keys(atendimento).some(key => {

                if (key === 'turnoId' || key === 'localAtendimentoId' || key === 'tipoAtendimentoId') {
                    return false;
                }

                const value = atendimento[key];
                return value !== "" && value !== null && value !== false && (!Array.isArray(value) || value.length > 0);
            });
        },
        handleDesejaPreencherChange(value) {
            if (value === false) {
                this.showConfirmation(
                    'Deseja realmente descartar os dados já preenchidos do IVFC 20?',
                    async () => {
                        this.model.ivcf.estadoSaudeGeral = null
                        this.model.ivcf.limitacaoCompras = null
                        this.model.ivcf.limitacaoGestaoFinanceira = null
                        this.model.ivcf.limitacaoTarefasDomesticas = null
                        this.model.ivcf.banhoIndependencia = null
                        this.model.ivcf.relatoEsquecimentoPorTerceiros = null
                        this.model.ivcf.esquecimentoPiorando = null
                        this.model.ivcf.esquecimentoImpactaAtividades = null
                        this.model.ivcf.humorTristezaDesanimo = null
                        this.model.ivcf.perdaInteresseAtividades = null
                        this.model.ivcf.limitacaoElevarBracos = null
                        this.model.ivcf.limitacaoMotricidadeFina = null
                        this.model.ivcf.perdaPesoNaoIntencional = null
                        this.model.ivcf.imcAbaixo22 = null
                        this.model.ivcf.panturrilhaAbaixo31 = null
                        this.model.ivcf.marchaLenta4mMaior5s = null
                        this.model.ivcf.dificuldadeCaminharImpactoAtividades = null
                        this.model.ivcf.quedasRecorrentes = null
                        this.model.ivcf.incontinencia = null
                        this.model.ivcf.problemaVisaoImpactoAtividades = null
                        this.model.ivcf.problemaAudicaoImpactoAtividades = null
                        this.model.ivcf.doencasCronicasMultiplas = null
                        this.model.ivcf.polifarmacia5OuMaisMedicamentos = null
                        this.model.ivcf.internacaoUltimos6Meses = null
                    },
                    async () => {
                        this.model.ivcf.desejaPreencher = true
                    }
                )
            }
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: Number, default: null },
        edit: { type: Boolean, required: false },
        isAmbulatorio: { type: Boolean, default: false },
        data: { type: Object, required: false },
    },
    watch: {
        'model': {
            handler(atendimento) {

                if (this.hasValue(atendimento.vigilancia) || this.hasValue(atendimento.condutaEncaminhamento)
                    || this.hasValue(atendimento.fornecimento) || this.hasValue(atendimento.atendimento)
                    || this.hasValue(atendimento.procedimentosQuantidade)
                    || this.hasValue(atendimento.procedimentos
                        .filter(procedimento => procedimento.origem == 'atencaoBasica'))) {

                            this.$emit('handleAtendimentoOdontologico', true)
                } else if (atendimento.cadastro.equipeId || atendimento.cadastro.usuarioAuxiliar
                    && atendimento.cadastro.usuarioAuxiliar.id) {

                        this.$emit('handleAtendimentoOdontologico', true)
                } else {

                    this.$emit('handleAtendimentoOdontologico', false)
                }
            },
            deep: true
        }
    }
}
</script>